/**
 * PUBLIC PAGE
 */
import React from "react";
import Contact from "../Components/Contact/Contact";
import Layout from "../Components/Layout/Layout";


export default function ContactPage() {
  return (
    <Layout>
    <Contact />
    </Layout>
  );
}
